// ============================================
// 🎨 THÈME & COULEURS
// Change ces valeurs pour personnaliser l'apparence
// ============================================

export const theme = {
  // Couleurs principales
  colors: {
    primary: '#00D9FF',        // Cyan - couleur d'accent
    primaryDark: '#00B4D8',    // Cyan foncé
    
    background: '#0a0f1c',     // Fond principal
    backgroundAlt: '#1a1f2e',  // Fond alternatif (cards)
    backgroundCard: 'rgba(26, 31, 46, 0.8)',
    
    text: '#e4e4e7',           // Texte principal
    textMuted: '#a1a1aa',      // Texte secondaire
    textDark: '#71717a',       // Texte discret
    
    success: '#28C840',        // Vert succès
    error: '#FF6B6B',          // Rouge erreur
    warning: '#FEBC2E',        // Jaune warning
  },
  
  // Polices
  fonts: {
    main: "'Outfit', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  
  // Bordures et ombres
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    xl: '20px',
    full: '9999px',
  },
  
  // Transitions
  transition: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  
  // Breakpoints
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px',
  }
};

// Styles de boutons réutilisables
export const buttonStyles = {
  primary: {
    background: `linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.primaryDark} 100%)`,
    color: theme.colors.background,
    padding: '1rem 2rem',
    borderRadius: theme.borderRadius.lg,
    fontWeight: '600',
    fontSize: '1rem',
    textDecoration: 'none',
    transition: theme.transition.normal,
    boxShadow: `0 4px 20px rgba(0, 217, 255, 0.3)`,
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  secondary: {
    background: 'transparent',
    color: theme.colors.primary,
    padding: '1rem 2rem',
    borderRadius: theme.borderRadius.lg,
    fontWeight: '600',
    fontSize: '1rem',
    textDecoration: 'none',
    border: `2px solid ${theme.colors.primary}`,
    transition: theme.transition.normal,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
};

// Style de carte réutilisable
export const cardStyle = {
  background: theme.colors.backgroundCard,
  borderRadius: theme.borderRadius.lg,
  padding: '2rem',
  border: `1px solid rgba(0, 217, 255, 0.1)`,
};
